module.exports = __webpack_public_path__ + "449becbf40e02936ea83ede6cb68b49e.png";